import { memo } from 'react';
import { CHARACTERS } from './characters.js';
import { Rig } from './rig.js';

export type AvatarState = 'idle' | 'dance' | 'woot' | 'meh' | 'dj';

export interface AvatarProps {
  avatarId: string;
  state?: AvatarState;
  /** Change this value to replay the one-shot celebratory burst. */
  burstKey?: string | number | null;
  size?: number;
  /** Staggers idle loops so a crowd does not move in lockstep (seconds). */
  phase?: number;
  highlight?: boolean;
  title?: string;
  className?: string;
}

/** Original CrowdSet avatar. Purely decorative unless `title` is provided. */
export const Avatar = memo(function Avatar({
  avatarId,
  state = 'idle',
  burstKey,
  size = 64,
  phase = 0,
  highlight = false,
  title,
  className,
}: AvatarProps) {
  const spec = CHARACTERS[avatarId] ?? CHARACTERS.nova!;
  return (
    <svg
      viewBox="-4 -8 88 128"
      width={size}
      height={(size * 128) / 88}
      className={['cs-av', className].filter(Boolean).join(' ')}
      data-state={state}
      data-highlight={highlight || undefined}
      style={{ ['--cs-phase' as string]: `${-phase}s` }}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      focusable="false"
    >
      {highlight && <ellipse cx="40" cy="113" rx="22" ry="5" className="cs-av-ring" />}
      <Rig c={spec} />
      {burstKey != null && (
        <g key={String(burstKey)} className="cs-av-burst" aria-hidden="true">
          <path d="M14 18 l-6 -6 M66 18 l6 -6 M40 -2 v-6 M8 40 h-7 M72 40 h7" />
          <circle cx="16" cy="4" r="2" />
          <circle cx="64" cy="4" r="2" />
        </g>
      )}
    </svg>
  );
});
